import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Databricks = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Databricks"
    height={height}
    width={width}
    title="Databricks logo"
    titleId="databricks-logo-title"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      fill="#FF3621"
      d="M466.6,210.8L255.6,330.4L31.3,202.9l-10.6,5.7v92.6l235,133.9l210.9-119.6v49.1L255.6,484.2L31.3,356.8
      l-10.6,5.7v15.7l235,133.9l235.7-133.9v-92.6l-10.6-5.7L255.6,407.3L45.4,287.7v-48.4l210.2,118.9l235.7-133.9v-91.1l-12-6.4L255.6,253.5L56.7,140.3L255.6,27.8l164.2,92.6l14.9-7.8v-11.4L255.6,0l-235,133.2v14.2l235,133.9l210.9-119.6V210.8z"
    />
  </SvgIcon>
);
